module.exports = __webpack_public_path__ + "img/caviar.b9243770.png";